module.exports = __webpack_public_path__ + "img/14f-doc-acao-prazo-regularizar.ebb8a188.png";